/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Station_Voice_Col_ExampleInputs */

const vi_station_voice_col_example = /** @type {(inputs: Station_Voice_Col_ExampleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ví dụ`)
};

/**

* @param {Station_Voice_Col_ExampleInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const station_voice_col_example = /** @type {((inputs?: Station_Voice_Col_ExampleInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Station_Voice_Col_ExampleInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_station_voice_col_example(inputs)
});